import { Link, useLocation } from "react-router-dom";
import { Home, Grid3X3, ShoppingCart, User } from "lucide-react";

const BottomNav = ({ cartCount = 0, isLoggedIn }) => {
  const { pathname } = useLocation();

  const tabs = [
    { key: "home", label: "Accueil", icon: Home, to: "/", match: (p) => p === "/" },
    { key: "categories", label: "Categories", icon: Grid3X3, to: "/categories", match: (p) => p === "/categories" || p.startsWith("/category") },
    { key: "cart", label: "Panier", icon: ShoppingCart, to: "/checkout", match: (p) => p === "/checkout", badge: cartCount },
    { key: "account", label: "Compte", icon: User, to: isLoggedIn ? "/profile" : "/auth", match: (p) => p === "/profile" || p === "/auth" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-neutral-200 md:hidden safe-area-bottom" data-testid="bottom-nav">
      <div className="flex items-stretch">
        {tabs.map(({ key, label, icon: Icon, to, match, badge }) => {
          const active = match(pathname);
          return (
            <Link
              key={key}
              to={to}
              className={`flex-1 flex flex-col items-center justify-center py-2.5 gap-0.5 transition-colors relative ${
                active ? "text-[#C9A84C]" : "text-neutral-400"
              }`}
              data-testid={`bottom-nav-${key}`}
            >
              <div className="relative">
                <Icon size={20} strokeWidth={active ? 2 : 1.5} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-[16px] bg-[#C9A84C] text-white text-[9px] font-bold flex items-center justify-center rounded-full px-1" data-testid="bottom-nav-cart-badge">
                    {badge > 9 ? "9+" : badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] tracking-wide ${active ? "font-semibold" : "font-light"}`}>{label}</span>
              {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#C9A84C] rounded-full" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
